import type AdobeEvent from '../AdobeEvent';
import Environment from './Environment';

export default class LocalStorageService {
  private readonly KEY: string = 'adobe-launch-event-storage';

  public getKey(): string {
    return Environment.location === 'production' ? this.KEY : this.KEY + '_np';
  }

  public get(): any[] {
    const storageItem = localStorage.getItem(this.KEY);
    return storageItem ? JSON.parse(storageItem) : ([] as object[]);
  }

  public addEventDataItem(event: AdobeEvent) {
    const eventDataItems: any[] = this.get();
    eventDataItems.push(event.getData());
    this.save(eventDataItems);
  }

  public save(eventDataItems: any[]) {
    localStorage.setItem(this.KEY, JSON.stringify(eventDataItems));
  }

  public clear() {
    localStorage.removeItem(this.KEY);
  }

  public removeItem(key: string) {
    const dataItems: any[] = this.get();
    const updatedEventDataItems = dataItems.filter((item) => item.event !== key);

    if (updatedEventDataItems.length < dataItems.length) {
      this.save(updatedEventDataItems);
    }
  }

  public hasItem(key: string): boolean {
    return this.get().some((item) => item.event === key);
  }
}
